<template>
  <v-data-table
    v-model="selectedRows"
    :headers="headerConfig"
    :items="items"
    hide-default-footer
    fixed-header
    class="elevation-0"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      v-slot:[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>

    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName" />
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    value: {
      required: false,
    },
    headerConfig: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    selectedRows: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
